export default "__VITE_ASSET__d800eca8__"